module.exports={
  "menu.contents": "Conteúdos"
}
